import React from "react";
import { GoBriefcase } from "react-icons/go";

const ProfessionalismCard = ({ title, percentage }) => {
  // Determine the color based on the percentage
  const getColor = (percentage) => {
    if (percentage >= 80) return "text-green-500";
    if (percentage >= 65) return "text-yellow";
    if (percentage >= 0) return "text-red-500";

    return "text-red-500";
  };

  return (
    <div className="flex items-center border-l-2 border-primary pl-2  ">
      {/* <GoBriefcase className="text-gray-600 mr-2" size={24} /> */}
      <span className=" md:text-lg lg:text-lg text-sm font-semibold text-[#747474] whitespace-nowrap ">
        {title}
        {":"}
      </span>
      <span
        className={`ml-2 ${getColor(
          percentage
        )} md:text-lg text-sm font-semibold`}
      >
        {" "}
        {percentage !== undefined ? percentage : "--"}
        {percentage !== undefined && percentage !== "-" && "%"}
      </span>
    </div>
  );
};

export default ProfessionalismCard;
